import React from "react";
import "./Form.css";
import Button from "./Button";

const Form = ({
  title,
  children,
  onSubmit,
  error,
  loading,
  submitText = "Submit",
  cancelText = "Cancel",
  onCancel,
  showCancel = true,
  showSubmit = true,
  footerLinks,
  containerClassName = "",
  rightButton = null,
  extraButtons = null,
}) => {
  const hasSideButtons = Boolean(rightButton || extraButtons);
  const buttonsClassName = hasSideButtons
    ? "form-buttons form-buttons-split"
    : "form-buttons";

  return (
    <div className={`form-container ${containerClassName}`}>
      <form className="form-form" onSubmit={onSubmit}>
        <h2>{title}</h2>
        {error && (
          <div className="form-error">
            {Array.isArray(error) ? error.join(", ") : error}
          </div>
        )}
        {children}
        {(showSubmit || (showCancel && onCancel) || rightButton || extraButtons) && (
          <div className={buttonsClassName}>
            {hasSideButtons ? (
              <>
                <div className="form-buttons-group">
                  {showSubmit && (
                    <Button
                      className="button-btn button-btn-blue "
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? "Loading..." : submitText}
                    </Button>
                  )}
                  {showCancel && onCancel && (
                    <Button
                      type="button"
                      className="button-btn button-btn-red"
                      onClick={onCancel}
                    >
                      {cancelText}
                    </Button>
                  )}
                  {extraButtons}
                </div>
                <div>{rightButton}</div>
              </>
            ) : (
              <>
                {showSubmit && (
                  <Button
                    className="button-btn button-btn-blue "
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : submitText}
                  </Button>
                )}
                {showCancel && onCancel && (
                  <Button
                    type="button"
                    className="button-btn button-btn-red"
                    onClick={onCancel}
                  >
                    {cancelText}
                  </Button>
                )}
              </>
            )}
          </div>
        )}
        {footerLinks}
      </form>
    </div>
  );
};

export default Form;
